import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import AgeConsentGate from "@/components/AgeConsentGate";
import InfoPage from "@/pages/InfoPage";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import ZelleInstructions from "@/pages/ZelleInstructions";
import ManualPayment from "@/pages/ManualPayment";
import Reorder from "@/pages/Reorder";

function Protected({ children, adminOnly }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center text-muted-foreground font-mono text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function Layout({ children }) {
  return (
    <div className="App grain flex flex-col min-h-screen">
      <div
        aria-hidden
        className="fixed inset-0 -z-10 pointer-events-none"
        style={{
          backgroundImage: `linear-gradient(rgba(10,24,54,0.72), rgba(10,24,54,0.86)), url(${process.env.PUBLIC_URL}/bg-catalog.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <AgeConsentGate />
      <AnnouncementBanner />
      <Navbar />
      <main className="flex-1 relative z-[2]">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/account" element={<Protected><Account /></Protected>} />
              <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/p/:slug" element={<InfoPage />} />
              <Route path="/payment/zelle" element={<ZelleInstructions />} />
              <Route path="/payment/transfer" element={<ManualPayment />} />
              <Route path="/reorder" element={<Reorder />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
